import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-vacancy-card',
  templateUrl: './vacancy-card.component.html',
  styleUrls: ['./vacancy-card.component.css']
})
export class VacancyCardComponent implements OnInit {
  @Input() vac = {};
  constructor() { }

  ngOnInit(): void {
  }

}
